import { Component } from '@angular/core';
import { soundpostGLAccountTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'GL Account Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostglaccounttype-form',
    templateUrl: './soundpostglaccounttype.form.component.html'
})
export class soundpostGLAccountTypeFormComponent extends BaseFormComponent {
    public record!: soundpostGLAccountTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'gLAccounts', sectionName: 'GL Accounts', isExpanded: false },
            { sectionKey: 'gLAccountTypes', sectionName: 'GL Account Types', isExpanded: false },
            { sectionKey: 'productGLAccounts', sectionName: 'Product GL Accounts', isExpanded: false }
        ]);
    }
}

